import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '🚀',
  title: 'Planificación Resuelta desde el Día 1',
  desc: 'Abrís el material, encontrás lo que necesitás y en minutos está listo.'
}, {
  emoji: '😊',
  title: 'Fin de los Domingos con Angustia',
  desc: 'Cuando el material está listo, la semana empieza con calma.'
}, {
  emoji: '💪',
  title: 'Docente Segura y Respaldada',
  desc: 'Cada actividad tiene su base. Cada informe tiene su estructura.'
}, {
  emoji: '❤️',
  title: 'Menos Desgaste, Más Vocación',
  desc: 'Enfocate en enseñar y acompañar, no en administrar y buscar.'
}];
export function BenefitsSection() {
  return <section className="py-16 md:py-24 pt-[60px] pb-[60px] bg-[#F8F8F8]" data-id="element-2">
      <div className="container mx-auto px-4 max-w-[1100px]" data-id="element-3">
        <div className="text-center mb-16" data-id="element-4">
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-[#1a2e5a] mb-6 leading-tight max-w-4xl mx-auto" data-id="element-5">
            EL IMPACTO REAL EN TU PRÁCTICA DOCENTE
          </h2>
          <p className="text-xl md:text-2xl text-[#1a2e5a]/70 font-medium max-w-2xl mx-auto" data-id="element-6">
            Esto es lo que realmente vas a lograr implementando La Agenda.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-7">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border border-[#f9d6e3] p-8 md:p-10 rounded-3xl shadow-sm" data-id="element-8">
              <div className="text-5xl mb-6" data-id="element-9">{b.emoji}</div>
              <h3 className="text-2xl font-bold text-[#1a2e5a] mb-4" data-id="element-10">
                {b.title}
              </h3>
              <p className="text-slate-600 leading-relaxed text-lg" data-id="element-11">{b.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}